import { createApp, defineAsyncComponent } from 'vue';

const app = createApp({
    components: {
        NavGlobalSearch: defineAsyncComponent(() => import('./NavGlobalSearch')),
    },
});

app.mount('#vue__nav__global__search');